import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, DropletIcon, ShieldIcon, CalendarIcon, SmoothieIcon } from './Icons';
export function WhatYouGet() {
  return <section className="w-full bg-cream py-10 md:py-24 px-5" data-id="element-513">
      <div className="max-w-2xl mx-auto" data-id="element-514">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-2xl md:text-4xl font-bold text-brown-dark text-center mb-4" data-id="element-515">
          Lo Que Recibes
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-body text-warm-gray text-center mb-7 md:mb-12 text-lg" data-id="element-516">
          Todo lo que necesitas para detener la caída en 7 días
        </motion.p>

        <div className="space-y-5" data-id="element-517">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white-soft rounded-xl p-5 md:p-6 border border-gold/15 flex gap-4 items-start" data-id="element-518">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-519">
              <BookIcon className="w-5 h-5 text-gold" data-id="element-520" />
            </div>
            <div data-id="element-521">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-522">
                La Guía Maestra Rescate Capilar 60+
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-523">
                El paso a paso para identificar y apagar el "incendio
                invisible".
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white-soft rounded-xl p-5 md:p-6 border border-gold/15 flex gap-4 items-start" data-id="element-524">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-525">
              <DropletIcon className="w-5 h-5 text-gold" data-id="element-526" />
            </div>
            <div data-id="element-527">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-528">
                La Receta del Elixir de Enfriamiento
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-529">
                3 ingredientes de cocina que detienen el picor en minutos.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white-soft rounded-xl p-5 md:p-6 border border-gold/15 flex gap-4 items-start" data-id="element-530">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-531">
              <ShieldIcon className="w-5 h-5 text-gold" data-id="element-532" />
            </div>
            <div data-id="element-533">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-534">
                Protocolo de Lavado "Presión Cero"
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-535">
                La técnica exacta para limpiar sin perder una sola hebra extra.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-white-soft rounded-xl p-5 md:p-6 border border-gold/15 flex gap-4 items-start" data-id="element-536">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-537">
              <CalendarIcon className="w-5 h-5 text-gold" data-id="element-538" />
            </div>
            <div data-id="element-539">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-540">
                Checklist de Rutina de 7 Días
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-541">
                Tu calendario de choque para ver resultados en una semana.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-white-soft rounded-xl p-5 md:p-6 border border-gold/15 flex gap-4 items-start" data-id="element-542">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 flex items-center justify-center" data-id="element-543">
              <SmoothieIcon className="w-5 h-5 text-gold" data-id="element-544" />
            </div>
            <div data-id="element-545">
              <h3 className="font-body text-lg font-semibold text-brown-dark mb-1" data-id="element-546">
                Plan de Nutrición de Emergencia
              </h3>
              <p className="font-body text-base text-warm-gray leading-relaxed" data-id="element-547">
                El batido "Fuerza Raíz" diseñado para la absorción de una mujer
                de 60+.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Product image 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mt-12 flex justify-center" data-id="element-548">
          <div className="relative" data-id="element-549">
            <div className="absolute inset-0 bg-sage/10 rounded-2xl blur-xl scale-105" data-id="element-550" />
            <img src="https://cdn.magicpatterns.com/uploads/kQUA9UxWLtKRoJ9U8S1o7J/hf_20260321_020830_34435e75-67b0-414a-8d6a-5e862ee4fab7.jpg" alt="Vista del protocolo completo Rescate Capilar 60+ mostrando la guía principal, el checklist de 7 días y el plan de nutrición Fuerza Raíz" className="relative w-full max-w-md rounded-2xl shadow-xl" data-id="element-551" />
          </div>
        </motion.div>
      </div>
    </section>;
}